
    import { boot } from '/src/main.js';
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => { boot(); });
    } else {
      boot();
    }
  